// src/config/config.js
// FTR-0019: la base URL del backend se fija por build con REACT_APP_API_BASE_URL (Create React App
// la incrusta en `npm start` desde .env.development y en `npm run build` desde .env.production;
// un override personal va en .env.development.local / .env.production.local, ignorados por Git).
// Sin variable se usa el host Railway de producción. Nunca poner secretos en REACT_APP_*.
// const DEFAULT_API_BASE_URL = "https://backendwinscore-production-8fd4.up.railway.app";
const DEFAULT_API_BASE_URL = "https://winscore-api.hayllis.com";

const API_BASE_URL = String(process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL).replace(/\/+$/, "");

export default API_BASE_URL;
